const HAVEN_IDENTITY_STORAGE_KEY = "haven-id-context";
const EXPIRY_MILLISECONDS = 3600000;
const isActive = (expiry) => {
    if (!expiry)
        return true;
    const diff = expiry - Date.now();
    return diff < EXPIRY_MILLISECONDS;
};
export const putStateInLocalStorage = (freshState) => {
    const stateWithExpiration = Object.assign(Object.assign({}, freshState), { createdAt: Date.now() });
    if (freshState) {
        window.localStorage.setItem(HAVEN_IDENTITY_STORAGE_KEY, JSON.stringify(stateWithExpiration));
    }
};
export const removeStateFromLocalStorage = () => {
    window.localStorage.removeItem(HAVEN_IDENTITY_STORAGE_KEY);
};
export const getStateFromStorage = () => {
    try {
        if (window.localStorage) {
            const json = window.localStorage.getItem(HAVEN_IDENTITY_STORAGE_KEY);
            if (json) {
                const state = JSON.parse(json);
                if (state && isActive(state.createdAt))
                    return state;
            }
        }
    }
    catch (e) {
        // could be an error reading from storage
    }
    return undefined;
};
